import Call from '../../Call.v2';
import {objToQs} from '../../Utils';

const Report = {
    get(type, filters, path = '') {
        return Call(`pushapi/report/v3/${type}/${path}?${objToQs(filters)}`);
    },
};

export default Report;



// WEBPACK FOOTER //
// ./src/services/API/components/Pushapi/Report.js